<template>
  	<v-autocomplete 
  		v-if="is_settings"
  		:items="billing_contracts" 
  		item-text="title" 
  		item-value="id" 
  		:placeholder="label || title" 
  		:label="label || title" 
  		v-model="val"
  		:disabled="disabled"
			:required="required||false"
			:rules="(required ? [(v) => !!v || label+' is required'] : undefined)"
      :clearable="(clearable == false ? false : true)"
			:multiple="multiple"
			:chips="multiple"
			:small-chips="multiple"
			:deletable-chips="multiple"
			hide-details>
  	></v-autocomplete>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import Vue from 'vue';
import SettingsModel from '@/models/settings.js';


export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required',
    "disabled", 
    "clearable",
    "multiple",
    "output_channel"
  ],
  data () {
  	return {
  		contracts: []
  	}
  },
  methods: {
  	update_contract_data () {
      var url = "content_list/" + this.list_id;
      var self = this;
      Vue.http.get(url).then((response) => {        
        var ts = self.$store.state.timestamp;       
        self.contracts = _.filter(response.body, function(contract) {
          if (contract.end_date < ts) return false;
          return true;
        });
      }, (response) => {
      });
    },

  },
  computed: {
 		is_settings() {
      if (this.settings.length > 0) {
      	this.update_contract_data();
      	return true;
      }
      return false;
    },
    settings () {
      return SettingsModel.list("billing_config");
    },
    list_id() {
      return this.settings[0].value.contracts_list_id;
    },
    billing_contracts () {
      var billing_customer_id = undefined;
      var ret = [];
      
      try {
        billing_customer_id = this.output_channel[0].meta.billing_customer;
      } catch (e) {
        // Siirrä returnit tänne
      }


      // If no default billing customer added to output channel, return all contracts
      if (billing_customer_id == undefined) {return this.contracts}

      _.each(this.contracts, function(contract) {
        if (contract.customer.id == billing_customer_id) {
          ret.push(contract);
        }
      })
      return ret;
    },

    val: {
      get () {
        return _.get(this.value, this.name) || "";
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
